import styled from 'styled-components';
import { grey1, red8 } from '../styles/colours.style';

import IconExclamation from 'approot/shared/icons/icon-exclamation';

export const IconError = styled(IconExclamation)`
  fill: ${red8};
  stroke: ${grey1};
`;
